import {Component, Input, OnInit} from '@angular/core';
import {ISharedModalTextarea} from '../../../shared-models/modals/shared-modal-textarea';
import {ModalControllerService} from '../../../shared-services/overlay/modal-controller.service';

@Component({
  selector: 'app-shared-modal-textarea',
  templateUrl: './shared-modal-textarea.component.html',
  styleUrls: ['./shared-modal-textarea.component.scss'],
  standalone: false,
})
export class SharedModalTextareaComponent implements ISharedModalTextarea, OnInit {

  @Input() title: string;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() initialValue: string = '';

  textareaValue: string = '';

  constructor(
    private modalController: ModalControllerService,
  ) {
  }

  ngOnInit(): void {
    this.textareaValue = this.initialValue;
  }

  onSave(): void {
    void this.modalController
      .dismiss({comment: this.textareaValue.trim()}, 'modal-save');
  }

  onCancel(): void {
    void this.modalController
      .dismiss(undefined, 'modal-cancel');
  }
}
